/**
 * UOM-aware quantity decimal policy.
 *
 * Count-like units (PCS, NOS, EA, …) must accept WHOLE numbers only — the
 * physical inventory is a discrete count of items. Weight/length/volume
 * units allow up to 3 decimals (matches Indian GST-style invoice rounding).
 */

const COUNT_UOMS = new Set([
  "PCS", "NOS", "NO", "EA", "PIECE", "PIECES", "PC", "UNIT", "UNITS",
  "BOX", "BOXES", "PACK", "PACKS", "BUNDLE", "BUNDLES",
  "PAIR", "PAIRS", "SET", "SETS", "DOZ", "DOZEN",
]);

/** Returns true if the UOM stores integer-only quantities. */
export function isCountUom(uom) {
  return COUNT_UOMS.has(String(uom || "").trim().toUpperCase());
}

/** Step value suitable for an <input type="number"> for this UOM. */
export function qtyStep(uom) {
  return isCountUom(uom) ? "1" : "0.001";
}

/** Clamp/round a raw input string to the UOM's precision. */
export function normalizeQty(value, uom) {
  const v = Number(value);
  if (!Number.isFinite(v)) return "";
  if (isCountUom(uom)) return String(Math.round(v));
  return String(Math.round(v * 1000) / 1000);
}
